/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Log_In_Nav_ItemInputs */

const en_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in`)
};

const id_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk`)
};

const ms_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log masuk`)
};

const ca_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sessió`)
};

const cs_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlásit se`)
};

const da_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log ind`)
};

const de_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden`)
};

const et_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logi sisse`)
};

const es_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión`)
};

const fr_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se connecter`)
};

const hr_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijava`)
};

const it_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi`)
};

const lv_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pieteikties`)
};

const lt_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prisijungti`)
};

const hu_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belépés`)
};

const nl_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in`)
};

const nb_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logg inn`)
};

const pl_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się`)
};

const pt_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer login`)
};

const ro_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autentificare`)
};

const sk_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prihlásiť sa`)
};

const sl_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijava`)
};

const fi_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjaudu sisään`)
};

const sv_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logga in`)
};

const vi_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập`)
};

const tr_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oturum aç`)
};

const el_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σύνδεση`)
};

const bg_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вход`)
};

const ru_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войти`)
};

const sr_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пријава`)
};

const uk_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вхід`)
};

const ka_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`შესვლა`)
};

const hi_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लॉग इन करें`)
};

const th_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลงชื่อเข้าใช้`)
};

const ko_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인`)
};

const zh_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录`)
};

const zh_tw_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入`)
};

const ja_log_in_nav_item = /** @type {(inputs: Log_In_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログイン`)
};

/**
* | output |
* | --- |
* | "Log in" |
*
* @param {Log_In_Nav_ItemInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const log_in_nav_item = /** @type {((inputs?: Log_In_Nav_ItemInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Log_In_Nav_ItemInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_log_in_nav_item(inputs)
	if (locale === "ms") return ms_log_in_nav_item(inputs)
	if (locale === "ca") return ca_log_in_nav_item(inputs)
	if (locale === "cs") return cs_log_in_nav_item(inputs)
	if (locale === "da") return da_log_in_nav_item(inputs)
	if (locale === "de") return de_log_in_nav_item(inputs)
	if (locale === "et") return et_log_in_nav_item(inputs)
	if (locale === "es") return es_log_in_nav_item(inputs)
	if (locale === "fr") return fr_log_in_nav_item(inputs)
	if (locale === "hr") return hr_log_in_nav_item(inputs)
	if (locale === "it") return it_log_in_nav_item(inputs)
	if (locale === "lv") return lv_log_in_nav_item(inputs)
	if (locale === "lt") return lt_log_in_nav_item(inputs)
	if (locale === "hu") return hu_log_in_nav_item(inputs)
	if (locale === "nl") return nl_log_in_nav_item(inputs)
	if (locale === "nb") return nb_log_in_nav_item(inputs)
	if (locale === "pl") return pl_log_in_nav_item(inputs)
	if (locale === "pt") return pt_log_in_nav_item(inputs)
	if (locale === "ro") return ro_log_in_nav_item(inputs)
	if (locale === "sk") return sk_log_in_nav_item(inputs)
	if (locale === "sl") return sl_log_in_nav_item(inputs)
	if (locale === "fi") return fi_log_in_nav_item(inputs)
	if (locale === "sv") return sv_log_in_nav_item(inputs)
	if (locale === "vi") return vi_log_in_nav_item(inputs)
	if (locale === "tr") return tr_log_in_nav_item(inputs)
	if (locale === "el") return el_log_in_nav_item(inputs)
	if (locale === "bg") return bg_log_in_nav_item(inputs)
	if (locale === "ru") return ru_log_in_nav_item(inputs)
	if (locale === "sr") return sr_log_in_nav_item(inputs)
	if (locale === "uk") return uk_log_in_nav_item(inputs)
	if (locale === "ka") return ka_log_in_nav_item(inputs)
	if (locale === "hi") return hi_log_in_nav_item(inputs)
	if (locale === "th") return th_log_in_nav_item(inputs)
	if (locale === "ko") return ko_log_in_nav_item(inputs)
	if (locale === "zh") return zh_log_in_nav_item(inputs)
	if (locale === "zh-tw") return zh_tw_log_in_nav_item(inputs)
	if (locale === "ja") return ja_log_in_nav_item(inputs)
	return en_log_in_nav_item(inputs)
});